export default __webpack_public_path__ + "static/media/egresadeIcon.c7199d88.png";